module.exports = __webpack_public_path__ + "static/Shadow-5cd8d1cc37e0abd7ec6d7fd451f0de46.jpg";